if(!customElements.get('predictive-search')) {

  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.limit = parseInt(this.dataset.limit);
      this.input = this.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.querySelector('.predictive-search');

      this.input.addEventListener('input', debounce((event) => {
        this.onChange(event);
      }, 100).bind(this));
    }

    onChange() {
      const searchTerm = this.input.value.trim();
      if (!searchTerm.length) {
        this.close();
        return;
      }
      this.getSearchResults(searchTerm);
    }

    getSearchResults(searchTerm) {
      fetch(`${routes.predictive_search_url}?q=${searchTerm}&resources[type]=page,product,collection&resources[limit]=${this.limit}&resources[options][unavailable_products]=hide&resources[options][fields]=title,body,product_type,variants.title&section_id=predictive-search`)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }

          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
          this.predictiveSearchResults.innerHTML = resultsMarkup;
          this.open();
        })
        .catch((error) => {
          this.close();
          throw error;
        });
    }

    open() {
      this.predictiveSearchResults.style.display = 'block';
    }

    close() {
      this.predictiveSearchResults.style.display = 'none';
    }
  }

  window.PredictiveSearch = PredictiveSearch;

  customElements.define('predictive-search', PredictiveSearch);
}
